module.exports = __webpack_public_path__ + "static/media/shapes-dark.3164f9c2.svg";